import { Col, Row } from 'react-bootstrap'

export default function Contact({ language }) {
  const today = new Date();
    const year = today.getFullYear();
  return (
      <div id="contact" className="contact">
        <div className='parent'>
          <div className='overlay '>
          <Row >
            <Col  sm="12" md="7" lg="7">
              <div className="info">
                  <ul>
                  <li><span> {language ?`Opening hours `:`Openingstijden`} </span>: Mon-Fri from 9:00-17:00</li>
                  <li><span>{language ?`Adress`:`Adres`}  </span>: Posthoornstraat 11 , 3011WD Rotterdam  </li>
                  <li><span>{language ?`Mobile`:`Mobiel`}  </span>: (+31)686195222</li>
                  <li> <span>Whatsapp </span>:  (+31)686195222</li>
                  <li> <span>Email </span>: info@stockdirect.nl</li>
                  <li> <span> {language ? `Vat-Id nr.` : `Btv-Id nr.`}  </span>: NL005222517B31</li>

                  <li> <span> {language ? `Chamber of commerce nr.` : `KvK nr.`}  </span>: 96649852</li>
                  <li><span>Eori nr. </span>: NL7349952016</li>
              </ul>
              </div>
              </Col>

                <Col   sm="12" md="5" lg="5">
                <iframe style={{ width: "100%", height: "95%" }} title="Giga terminal" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Posthoornstraat11,%20Rotterdam,the%20Neetheerlands+(Giga%20Terminal)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/">gps devices</a>
                </iframe>
                </Col>
          </Row>
          <Row>
              <Col sm="12">
                <footer>
                  <h4>copyright &copy; {year}</h4>
                </footer>
              </Col>
          </Row>
          </div>
        </div>
      </div>
  

  )
}